/* eslint-disable no-inline-styles/no-inline-styles */
import error404Image from '../../../images/icons/404.png';
import ButtonComponent from '../ButtonComponent/ButtonComponent';

import './ErrorFallback.scss';

import React from 'react';

export default function FallbackRender() {
  return (
    <div className="error-fallback-container">
      <div className="error-fallback-inner-container">
        <div className="error-fallback-left-container">
          <h1>
            😵‍💫 Aww shucks,
            <br />
            something went wrong!
          </h1>
          <div>
            <p style={{ paddingBottom: 32 }}>It&apos;s not you. It&apos;s us. Can you try refreshing?</p>
            <p>
              If it doesn&apos;t work, please reach out to us in the support
              <br />
              chat below, or email <a href="mailto:tech@getsaral.com">tech@getsaral.com</a>.
            </p>
          </div>
          <div className="buttons-container">
            <ButtonComponent
              onClick={() => {
                window.location.href = '/dashboard';
              }}
            >
              🏠 Go to Home
            </ButtonComponent>
            <ButtonComponent variant="secondary" onClick={() => window.location.reload()}>
              Refresh
            </ButtonComponent>
          </div>
        </div>
        <div className="error-fallback-right-container">
          <img src={error404Image} alt="" />
        </div>
      </div>
    </div>
  );
}
